/**
 * Opens a fresh, throwaway <input type=file> to prompt the user for a file. A fresh
 * input is used rather than reusing an existing hidden one — re-triggering an
 * already-populated display:none input is unreliable across browsers. Safari also
 * ignores .click() on an input that isn't attached to the DOM, so it's attached first.
 * Resolves with the chosen file, or null if the picker is dismissed without one.
 */
export function pickFile(document: Document, accept: string): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.style.display = "none";
    const cleanup = (file: File | null) => {
      input.remove();
      resolve(file);
    };
    input.addEventListener("change", () => cleanup(input.files?.[0] ?? null));
    input.addEventListener("cancel", () => cleanup(null));
    document.body.appendChild(input);
    input.click();
  });
}
